// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1CGKd","topo":"Header_topo__2a_L0","logoImg":"Header_logoImg__3rdXL"};